var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppStyleComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.477 2 2 6.477 2 12c0 1.328.26 2.598.732 3.76l.084.211.005.014-.001.005a7.06 7.06 0 0 1-.03.183l-.597 3.587c-.027.16-.057.34-.069.496-.013.17-.017.44.106.727a1.5 1.5 0 0 0 .787.787c.286.123.557.119.727.106.156-.012.336-.042.496-.069l3.587-.598.183-.029h.005l.014.005c.045.016.105.04.21.083A9.973 9.973 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2ZM8 8.5a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H8ZM8 12a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H8Z",
  fill: "#fff"
})));
export default SvgAppStyleComment;